export default __webpack_public_path__ + "static/stefan-273bfed689b91274dc08fff2b07794e1.png";